
const Loader = require('./skrollex');

let instance = null; // singleton pt. 1/3

class ScrollAnimations {

	constructor(el, params){

		// singleton pt. 2/3
		// is only called by first instance

		if(!instance){

			instance = this;

			// vars

			this.$el = $(el);
			this.params = params;

			this.skrollex;

			// init

			this.init();
		}

		// singleton pt. 3/3

		return instance;
	}

	init(){

		this.scrollObj;

		this.addListeners();
		this.skrollex();
	}

	// event listeners

	addListeners(){
		window.vent.on('scrollTo', this._onScrollTo, this);
		window.vent.on('cancelScroll', this._onCancelScroll, this);
	}

	// listener methods

	_onScrollTo(e, params){

		let $window = $(window);
		let animationTime = (params && !isNaN(params.animationTime)) ? params.animationTime : 0.8;
		let scrollTop = (params && !isNaN(params.scrollTop)) ? params.scrollTop : 0;

		window.vent.trigger('windowResize');

		this.scrollObj = {scrollTop: $window.scrollTop()};
		TweenMax.to(this.scrollObj, animationTime, {scrollTop: scrollTop, ease:'scrollEase', onUpdate:() => {
			$window.scrollTop(this.scrollObj.scrollTop);
		}});
	}

	_onCancelScroll(){
		if(this.scrollObj){
			TweenMax.killTweensOf(this.scrollObj);
			this.scrollObj = null;
		}
	}

	// skrollex initialization

	skrollex(){

		this.skrollex = new Skrollex({

			minWidth: 1024,
			staggerBefore: 0.04,
			staggerAfter: 0.04,

			onRender: function(e, params){

			},

			onPendingShow: function(e, params){

			},

			onPendingHide: function(e, params){

			},

			onViewportEnter: function(e, params){

				// if ( e.$el.is('video') ) {
				// 	e.$el[0].play();
				// }

				// let attr = e.$el.data('plyr-video');

				// if ( typeof attr !== typeof undefined && attr !== false ) {
				// 	e.$el.triggerHandler('play');
				// }
			},

			onViewportLeave: function(e, params){

				// if ( e.$el.is('video') ) {
				// 	e.$el[0].pause();
				// }

				// let attr = e.$el.data('plyr-video');

				// if ( typeof attr !== typeof undefined && attr !== false ) {
				// 	e.$el.triggerHandler('pause');
				// }
			},

			onShow: function(e, params){

				let $el = e.$el;
				$el.addClass('anim-start');

				window.utils.AnimationUtils.oneTransitionComplete($el, () => {

					$el.removeClass('anim-start');
					$el.addClass('anim-in');

					checkUniqueStarts();

				}, () => {

					$el.removeClass('anim-in');
					$el.addClass('anim-in-complete');

					checkUniqueCompletes();

				}, true);

				//

				function checkUniqueStarts(){

					// if(typeof($el.attr('data-split-text')) !== 'undefined'){

					// 	$el.find('.line').each((index, value) => {

					// 		let $line = $(value);

					// 		TweenMax.set($line, {
					// 			'transform-origin' : Math.round(Math.random() * 100) + '% ' + Math.round(Math.random() * 100) + '%',
					// 			'rotation' : (Math.random() * 4 - Math.random() * 4) * 15,
					// 			'y' : 100 + Math.round(Math.random() * 4) * 20
					// 		});
					// 	});
					// }
				}

				function checkUniqueCompletes(){

				}
			},

			onHide: function(e, params){

			},

			onRemove: function(e, params){

			}
		});
	}
}

module.exports = ScrollAnimations;
